/* =============================================================
 * import
 * ========================================================== */
import {eventObserver} from "./eventObserver";
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {mediaQuery} from "./common";
import {smoother} from "./parallax";
import {isMobile} from "./common";
// import {slideToggle} from "./slide";

gsap.registerPlugin(CustomEase);
CustomEase.create("slide", ".32, .95, .6, 1");
CustomEase.create("curtain", ".25, .43, .78, .71");

/* =============================================================
 * globalNavi
 * グローバルナビに関する実行関数
 * ========================================================== */
export function globalNavi(data) {

  const parentElements = document.querySelectorAll('.header .main_nav_list_item');
  const touchPoint = document.querySelectorAll('.touch_point_list_item_link');
  const hum = document.querySelector('.hum');
  const close = document.querySelector('#close');
  const logo = document.querySelector('.header_logo_link');
  const listeners = [];
  let child;
  let listElements;

  if (mediaQuery(window.innerWidth) === 'sp') {
    listElements = document.querySelectorAll('.header_nav_list_item_link, .header_content .header_content_nav_list_item_link, .header_content .main_nav_child_item_link, .header_content .header_user_list_item_link');
  } else {
    listElements = document.querySelectorAll('.header_content_logo_link, .header_content .header_content_nav_list_item_link, .header_content .main_nav_list_item_link, .header_content .main_nav_child_item_link, .header_content .header_user_list_item_link');
  }

  const addEvent = () => {

    if (hum) {
      hum.addEventListener('click', humberger);
      close.addEventListener('click', humberger);
      logo.addEventListener('click', humberger);
      // listeners.push([hum, 'click', humberger]); // こちらを使用すると、初回のページ遷移後にイベントが削除される現象を確認したため削除。
      // listeners.push([close, 'click', humberger]);
      // listeners.push([logo, 'click', humberger]);

      listElements.forEach((elem) => {
        if (elem.parentNode.classList.contains('parent') === false) {
          elem.addEventListener('click', humberger, false);
          // listeners.push([elem, 'click', humberger]);
        }
      });
      touchPoint.forEach((elem) => {
        elem.addEventListener('click', humberger, false);
        // listeners.push([elem, 'click', humberger]);
      });
    }


    if (mediaQuery(window.innerWidth) === 'sp') {
      // SP
      parentElements.forEach((elem) => {
        child = elem.querySelector('.main_nav_list_item_link');
        child.addEventListener('click', subMenu, false);
        // listeners.push([child, 'click', subMenu]);
      });

    }

    eventObserver.observeEvents(listeners);
  };

  const removeEvent = () => {

    if (hum) {
      hum.removeEventListener('click', humberger);
      close.removeEventListener('click', humberger);
      logo.removeEventListener('click', humberger);
      listElements.forEach((elem) => {
        elem.removeEventListener('click', humberger, false);
      });
      touchPoint.forEach((elem) => {
        elem.removeEventListener('click', humberger, false);
      });
    }

    if (mediaQuery(window.innerWidth) === 'sp') {

      // SP
      // navBtn.removeEventListener('click', navToggle, false);
      parentElements.forEach((elem) => {
        child = elem.querySelector('.main_nav_list_item_link');
        child.removeEventListener('click', subMenu, false);
        // listeners.push([child, 'click', subMenu]);
      });

    }


    const headerContent = document.querySelector('.header_content');
    const headerGnavList = document.querySelectorAll('.header_gnav_list_item');
    const headerTouchpoint = document.querySelectorAll('.touch_point_list_item_link');
    headerContent.removeAttribute('style');
    headerGnavList.forEach((elem) => {
      elem.removeAttribute('style');
    });
    headerTouchpoint.forEach((elem) => {
      elem.removeAttribute('style');
    });
  };

  addEvent();

  window.addEventListener('resize', function() {
    if (!isMobile()) {
      removeEvent();
      addEvent();
    }
  });

  window.addEventListener('orientationchange', function() {
    removeEvent();
    addEvent();
  });


  // junior / senior のヘッダークラス付け替え
  if (data && data.container) {
    if (data.container.classList.contains('home')) {
      switchDirClasses('home');
    } else if (data.container.classList.contains('junior')) {
      switchDirClasses('junior');
    } else if (data.container.classList.contains('senior')) {
      switchDirClasses('senior');
    } else if (data.container.classList.contains('page-about')) {
      switchDirClasses('about');
    } else {
      switchDirClasses();
    }
  }


  function switchDirClasses(className) {
    const items = document.querySelectorAll('.header_nav .header_nav_list_item');
    items.forEach((item) => {
      // 既存のselectedクラスを全て削除
      item.classList.remove('selected');

      // item要素のdata-dir属性と引数classNameが一致するかチェック
      if (item.getAttribute('data-dir') === className) {
        // 一致する場合はselectedクラスを付与
        item.classList.add('selected');
      }
    });
  }
}


/* =============================================================
 * humberger
 * ハンバーガーメニューの制御
 * ========================================================== */

export function humberger() {

  const hum = document.querySelector('.hum');
  const header = document.getElementById('header');
  const filter = document.getElementById('filter');


  if (hum) {

    if (hum.classList.contains('ing')) {
      return;
    }

    if (hum.classList.contains('close')) {
      // 閉じている時の挙動
      if (this.classList.contains('header_logo_link')) return; // ヘッダーロゴの場合は開かない
      if (this.classList.contains('header_nav_list_item_link')) return; // ヘッダー学校総合ナビの場合は開かない
      if (this.classList.contains('touch_point_list_item_link')) return; // サイドバーのオファーの場合は開かない

      // 開く
      hum.classList.remove('close');
      header.classList.remove('close');
      filter.classList.remove('close');

      hum.classList.toggle('open');
      header.classList.toggle('open');
      filter.classList.toggle('open');

      hum.classList.add('ing');
      humbergerAnim('open');

    } else if (hum.classList.contains('open')) {
      // 開いている時の挙動
      if (this.classList.contains('main_nav_list_item_link') && isMobile()) return; // SP時の親メニューは子メニュー展開のみで用いる

      // 閉じる
      hum.classList.add('close');
      header.classList.add('close');
      filter.classList.add('close');

      hum.classList.toggle('open');
      header.classList.toggle('open');
      filter.classList.toggle('open');

      hum.classList.add('ing');
      humbergerAnim('close');

    } else {

      // 初動
      if (this.classList.contains('header_logo_link')) return; // ヘッダーロゴの場合は開かない
      if (this.classList.contains('header_nav_list_item_link')) return; // ヘッダー学校総合ナビの場合は開かない
      if (this.classList.contains('touch_point_list_item_link')) return; // サイドバーのオファーの場合は開かない

      hum.classList.toggle('open');
      header.classList.toggle('open');
      filter.classList.toggle('open');

      hum.classList.add('ing');
      humbergerAnim('open');
    }
  }
}


function humbergerAnim(which) {

  const tl = gsap.timeline({
    repeat: 0,
    ease: "curtain",
  });

  const hum = document.querySelector('#hum');
  const closeBtn = document.querySelector('#close');
  const nav = document.querySelector('.header_content');
  const logo = nav.querySelector('.header_content_logo');
  const mainLists = nav.querySelectorAll('.header .main_nav_list');
  const topLists = nav.querySelectorAll('.header_content_nav_list_item');
  const relatedLists = nav.querySelectorAll('.main_related_list_item');
  const userLists = nav.querySelectorAll('.header_user_list_item');
  const snsLists = nav.querySelectorAll('.sns_list_item');
  const lists = [logo, topLists, relatedLists, userLists, snsLists];

  if (which === 'open') {

    // open animation
    gsap.set(nav, {
      autoAlpha: 1,
    });

    tl
      .fromTo(hum, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .6,
      }, "<")
      .add(function() {
        lockScroll(); // スクロールを止める
      }, ">")

      .call(toggleClass, [hum, 'ing'], ">")

      .add(function() {
        mainLists.forEach(navList => {
          const items = navList.querySelectorAll('.main_nav_list_item, .main_nav_child_item');
          gsap.fromTo(items, {
            x: '30%',
            autoAlpha: 0.5,
            webkitClipPath: 'inset(0% 0% 0% 100%)',
            clipPath: 'inset(0% 0% 0% 100%)',
          }, {
            x: '0%',
            autoAlpha: 1,
            webkitClipPath: 'inset(0% 0% 0% 0%)',
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: .5,
            stagger: {
              each: .05,
            },
          });
        });
      }, ">-=.6")

      .fromTo(lists, {
        x: '30%',
        autoAlpha: 0.5,
        webkitClipPath: 'inset(0% 0% 0% 100%)',
        clipPath: 'inset(0% 0% 0% 100%)',
      }, {
        x: '0%',
        autoAlpha: 1,
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .5,
        stagger: {
          each: .05,
        },
      }, "<")

      .fromTo(closeBtn, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .6,
      }, ">")
    ;

  } else {

    // close animation

    tl
      .fromTo(closeBtn, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .8,
      }, "<")
      .add(function() {
        unlockScroll(); // スクロールのロックを解除
      }, "<")

      .add(function() {
        mainLists.forEach(navList => {
          const items = navList.querySelectorAll('.main_nav_list_item, .main_nav_child_item');
          gsap.fromTo(items, {
            x: '0%',
            autoAlpha: 1,
            webkitClipPath: 'inset(0% 0% 0% 0%)',
            clipPath: 'inset(0% 0% 0% 0%)',
          }, {
            // x: '-30%',
            autoAlpha: 0.5,
            webkitClipPath: 'inset(0% 100% 0% 0%)',
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .5,
            stagger: {
              each: .05,
            },
          });
        });
      }, "<+=0")

      .fromTo(lists, {
        x: '0%',
        autoAlpha: 1,
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .5,
      }, {
        // x: '-30%',
        autoAlpha: 0.5,
        webkitClipPath: 'inset(0% 100% 0% 0%)',
        clipPath: 'inset(0% 100% 0% 0%)',
        duration: .5,
      }, "<")

      .fromTo(hum, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .6,
      }, ">")

      .set(nav, {
        autoAlpha: 0,
        zIndex: 0,
      }, ">")

      .call(toggleClass, [hum, 'ing'], ">")
    ;
  }
}


function subMenu(e) {
  e.preventDefault(); // デフォルトのページ遷移をキャンセル
  e.stopPropagation(); // イベントの伝播を停止

  let parent = e.target;

  // クリックされた要素が main_nav_list_item_link_txt ならその親要素を取得
  if (parent.classList.contains('main_nav_list_item_link_txt')) {
    parent = parent.parentElement;
  }

  const target = parent.nextElementSibling;
  if (target.classList.contains('open')) {
    gsap.to(target, {
      autoAlpha: 0,
      height: 0,
    });
    parent.classList.remove('open');
    target.classList.remove('open');
  } else {
    gsap.set(target, {
      height: 0,
    });
    gsap.to(target, {
      autoAlpha: 1,
      height: 'auto',
    });
    parent.classList.add('open');
    target.classList.add('open');
  }
}


/* =============================================================
 * toggleClass
 * ========================================================== */

function toggleClass(e, n) {
  e.classList.toggle(n);
}

/*
function navToggle() {
  const btn = document.querySelector('.header_nav_selected');
  const list = document.querySelector('.header_nav_list');
  if (list.classList.contains('is-open')) {
    // close
    gsap.to(list, {
      autoAlpha: 0,
      ease: 'slide',
      duration: 1,
    });
  } else {
    // open
    gsap.to(list, {
      autoAlpha: 1,
      ease: 'slide',
      duration: 1,
    });
  }
  btn.classList.toggle('is-open');
  list.classList.toggle('is-open');
}
*/


/* =============================================================
 * lockScroll
 * ========================================================== */
let scrollPosition = 0;

export function lockScroll(option = true) {
  if (!isMobile()) {
    // PC時の制御
    scrollPosition = smoother.offset('.main'); // スクロール領域の位置を取得
    smoother.paused(true);
    smoother.scrollTo(scrollPosition); // 位置ずれを防ぐため取得した位置に強制スクロール
  } else {
    // SP時の制御
    if (option === true) {
      scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.documentElement.classList.add('is-fixed'); // スクロール禁止
    } else {
      // document.documentElement.classList.add('is-fixed'); // スクロール禁止
    }
  }
}

export function unlockScroll(option = true) {
  if (!isMobile()) {
    // PC時の制御
    smoother.paused(false);
  } else {
    // SP時の制御
    if (option === true) {
      document.documentElement.classList.remove('is-fixed'); // スクロール許可
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      window.scrollTo(0, scrollPosition);
    } else {
      // document.documentElement.classList.remove('is-fixed'); // スクロール許可
    }
  }
}
